import removeFromArray from './removeFromArray';

export default function toggleArrayValue<T>(array: T[], value: T): T[] {
  if (array.includes(value)) {
    return removeFromArray(array, value);
  } else {
    return [...array, value];
  }
}
